import _extends from 'babel-runtime/helpers/extends';

import ExtraManage from './extra-manage.vue';
import AuthorizeRevenue from '../components/authorize-revenue.vue';
import { grantSupplement, getGrantRevenue } from '@/api/grant/grant';

export default {
  components: {
    ExtraManage: ExtraManage,
    AuthorizeRevenue: AuthorizeRevenue
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    authorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    rules: function rules() {
      var validateInit = function validateInit(rule, value, callback) {
        var reg = /(^[1-9]\d*$)/;
        if (reg.test(value) || value === 0) {
          callback();
        } else {
          callback(new Error('请输入正整数'));
        }
      };

      return {
        download_num: [{
          required: false,
          trigger: 'change',
          validator: validateInit
        }, {
          required: false,
          trigger: 'change',
          validator: function validator(rule, value, callback) {
            if (value === 0 || value >= 10) {
              callback();
            } else {
              callback(new Error('最少购买10个'));
            }
          }
        }],
        online_num: [{
          required: false,
          trigger: 'change',
          validator: validateInit
        }],
        delay_days: [{
          required: false,
          trigger: 'change',
          validator: validateInit
        }],
        storage: [{
          required: false,
          trigger: 'change',
          validator: validateInit
        }]
      };
    },


    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    },

    dialogAttrs: function dialogAttrs() {
      return _extends({}, this.$attrs);
    },
    canFetchRevenue: function canFetchRevenue() {
      // 根据服务端计算的逻辑，涉及到计算影响的字段：
      // ExpiredDate、AccountType、SubscribeType、ExtraOnlineLimit、ExtraDownloads
      var _formValue = this.formValue,
          delay_days = _formValue.delay_days,
          download_num = _formValue.download_num,
          online_num = _formValue.online_num,
          storage = _formValue.storage,
          video_credits = _formValue.video_credits,
          voice_slots = _formValue.voice_slots,
          voice_edits = _formValue.voice_edits;

      return [delay_days, download_num, online_num, storage, video_credits, voice_slots, voice_edits].join('-');
    }
  },
  data: function data() {
    return {
      loading: false,
      formValue: {
        revenue: 0, // 授权金额
        delay_days: 0,
        download_num: 0,
        online_num: 0,
        parent_id: 0,
        storage: 0,
        video_num: 0,
        video_credits: 0,
        voice_slots: 0,
        voice_edits: 0
      }
    };
  },


  watch: {
    dialogVisible: function dialogVisible(val) {
      if (this.$refs.form) {
        var form = this.$refs.form;
        form.resetFields();
        form.clearValidate();
        this.formValue.download_num = 0;
      }
    },
    canFetchRevenue: function canFetchRevenue() {
      var _this = this;

      // if (this.formValue.account_type === 'normal') {
      var params = this.getParams();
      getGrantRevenue({
        downloads: params.download_num,
        online_limit: params.online_num,
        plan_id: this.authorizeInfo.plan_id,
        is_scale_storage: params.storage === 0 ? 2 : 1,
        days: params.delay_days,
        video_credits: params.video_credits || 0,
        voice_slots: params.voice_slots || 0,
        voice_edits: params.voice_edits || 0
      }, true /* 开启错误时候不展示错误消息 */
      ).then(function (res) {
        // eslint-disable-next-line vue/no-mutating-props
        _this.formValue.revenue = res.data.data.revenue;
      });
      // }
    }
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('update:visible', false);
    },
    handleSaveSuccess: function handleSaveSuccess() {
      this.closeDialog();
      this.$emit('save-success');
    },
    getParams: function getParams() {
      return _extends({}, this.formValue, {
        parent_id: this.authorizeInfo.id
      });
    },
    submit: function submit() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          grantSupplement(_this2.getParams()).then(function () {
            _this2.handleSaveSuccess();
          }).finally(function () {
            _this2.loading = false;
          });
        }
      });
    },
    cancel: function cancel() {
      this.closeDialog();
      this.$emit('cancel');
    }
  }
};